<template lang="pug">
    div
        div(v-if="isLoading")
            Loader
        div(v-else)
            b-form.w-100(@submit.prevent="editSystem")
                table.table.table-sm
                    thead
                        th Organisation Name
                        th Assistance Type
                        th Officer in Charge
                        th Email
                        th Contact Number
                        th
                    tr(v-for="(item, index) in client.new_System_Client_new_Client")
                        td
                            b-form-input(v-model="item.new_organisationname" type="text" required)
                        td
                            b-form-input(v-model="item.new_assistancetype" type="text" required)
                        td
                            b-form-input(v-model="item.new_officerincharge" type="text" required)
                        td
                            b-form-input(v-model="item.new_email" type="email" required)
                        td
                            b-form-input(v-model="item.new_contactnumber" type="text" required)
                        td
                            b-button(@click="removeItem(index)")
                                b-icon(icon="trash")
                b-button(@click="addItem()") + Add System
                hr
                b-button(type="submit" :disabled="isSubmitting") {{ isSubmitting ? 'Saving...' : 'Save'}}
</template>

<script>
import dayjs from 'dayjs';
import Loader from '@/components/loader/Loading.vue';

export default {
    name: 'EditClientMedicationComponent',
    components: {
        Loader
    },
    props: {
        clientId: {
            type: String,
            required: true
        },
        client: {
            type: Object,
            required: false
        }
    },
    computed: {
        /*client(){
            return this.$store.state.client;
        },*/
    },
    data(){
        return{
            isLoading: true,
            isSubmitting: false,
            itemToDeleteId: [],
            // use to clean up raw data
            tableColumn: {
                new_organisationname: null,
                new_assistancetype: null,
                new_officerincharge: null,
                new_email: null,
                new_contactnumber: null,
            }
        }
    },
    async mounted() {
        if(!this.client) {
            let res = await this.getClient();
            this.isLoading = res ? false : true;
            return;
        }        

        this.isLoading = false;
    },
    methods: {
        dayjs,
        async getClient() {
            return await this.$store.dispatch('getClient', this.clientId).then((res)=>{
                this.client = res;
                return true;
            }).catch((err)=>{
                window.alert(err);
                return false;
            })
        },
        async editSystem() {
            this.isSubmitting = true;
            let promiseItems = [];

            for(let item of this.client.new_System_Client_new_Client) {
                // clean up payload
                for(let key in this.tableColumn) {
                    this.tableColumn[key] = item[key];
                }

                // post new item
                if(!item.new_systemid) {
                    let promiseItem = new Promise((resolve, reject) => {
                        try {
                            let result = this.$store.dispatch('addSystem', {clientId:this.clientId, payload:this.tableColumn});
                            resolve(result);
                        } catch (err) {
                            reject(err);
                        }
                    });
                    promiseItems.push(promiseItem);
                }

                // patch existing item
                if(item.new_systemid) {
                    let promiseItem = new Promise((resolve, reject) => {
                        try {
                            let result = this.$store.dispatch('editSystem', {systemId:item.new_systemid, payload:this.tableColumn});
                            resolve(result);
                        } catch (err) {
                            reject(err);
                        }
                    });
                    promiseItems.push(promiseItem);
                }
            }

            // delete item
            for(let itemId of this.itemToDeleteId) {
                let promiseItem = new Promise((resolve, reject) => {
                    try {
                        let result = this.$store.dispatch('deleteSystem', itemId);
                        resolve(result);
                    } catch (err) {
                        reject(err);
                    }
                });
                promiseItems.push(promiseItem);
            }

            Promise.all(promiseItems).then(()=>{
                this.isSubmitting = false;
                window.location.reload();
            }).catch((err)=>{
                window.alert(`Something when wrong when editing system client in.\n${err}`);
            });
        },
        addItem() {
            this.client.new_System_Client_new_Client.push({
                new_organisationname: null,
                new_assistancetype: null,
                new_officerincharge: null,
                new_email: null,
                new_contactnumber: null,
            });
        },
        removeItem(index) {
            if (index < 0) { return false; }

            // remove from array
            let item = this.client.new_System_Client_new_Client[index];

            // if it's an item from the db, temporary store id to delete when user click save
            if(item.new_systemid) {
                this.itemToDeleteId.push(item.new_systemid);
            }

            this.client.new_System_Client_new_Client.splice(index, 1);
        }
    }
}
</script>

<style>
</style>